import React from 'react';
import { CustomPicker } from 'react-color';
import { Text } from 'ui';
import { Hue, Saturation, EditableInput } from 'react-color/lib/components/common';

class ColorPickerComponent extends React.Component {
  render() {
    return (
      <div>
        <div style={{position:'relative', height:80, marginBottom:10}}>
          <Saturation
            {...this.props}
          />
        </div>
        <div style={{position:'relative', height:12, marginBottom:12}}>
          <Hue
            {...this.props}
            // pointer={}
            direction="horizontal"
          />
        </div>
        <div style={{display:'flex', alignItems:'center'}}>
          <Text small block style={{marginRight:4}}>R</Text>
          <EditableInput
            style={{input:{width:24, padding:8, border:"1px solid #aaa", fontSize:12, marginRight:8}}}
            value={ this.props.rgb.r }
            {...this.props}
          />
          <Text small block style={{marginRight:4}}>G</Text>
          <EditableInput
            style={{input:{width:24, padding:8, border:"1px solid #aaa", fontSize:12, marginRight:8}}}
            value={ this.props.rgb.g }
            {...this.props}
          />
          <Text small block style={{marginRight:4}}>B</Text>
          <EditableInput
            style={{input:{width:24, padding:8, border:"1px solid #aaa", fontSize:12}}}
            value={ this.props.rgb.b }
            {...this.props}
          />
        </div>
      </div>
    );
  }
}

export default CustomPicker(ColorPickerComponent);